<app-data-grid-comp
    category="Buy-Sell-Plans-Reviewers"
    [gridId]="gridId"
    [columns]="columns"
    [hideActionButtons]="false"
    [filterCategories]="filterCategories"
    [gridDataResult]="gridDataResult"
    [pageSize]="pageSize"
    [skip]="skip"
    [clearSelectedItems]="clearSelectedItems"
    actionButtonText="Add"
    [rowSelectionSettings]="{
        canSelectRows: true,
        selectableMode: 'multiple',
        selectRowBy: 'id'
    }"
    clickableRows="true"
    [isLoading]="isLoading"
    searchable="true"
    showRefreshButton="true"
    (emitRefreshEvent)="getBuySellPlanReviewers()"
    [sortable]="{
        mode: 'multiple'
    }"
    [sort]="sort"
    [sortableColumns]="sortableColumns"
    (emitOpenDialogEvent)="openAddReviewersDialog($event)"
    (emitGridStateChangeEvent)="gridStateChange($event)"
    (emitDeleteEvent)="openConfirmDeleteDialog($event)"
></app-data-grid-comp>